import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'booking.notes.title',
    defaultMessage: 'Notes',
  },
  description: {
    id: 'booking.notes.description',
    defaultMessage:
      'Provide any information like allergies or accesbility requirements you need the provider to know about.',
  },
});
